<template>
	<div>
		<h2>Crear Horario</h2>
		<div class="flex flex-wrap">
			<div class="w-full md:w-1/6">
				<!-- Se oculta el switch por el momento -->
				<p class="text-primary vs-list--title">Medias Horas</p>
				<ul class="con-s">
			    <li>
			      <vs-switch 
				      color="dark" 
				      icon-pack="feather" 
				      vs-icon-on="icon-check-circle" 
				      vs-icon-off="icon-slash"
				      @change="changeMediasHorasSwitch" 
				      v-model="mediasHoras">
			        <span slot="on">SÍ</span>
			        <span slot="off">NO</span>
			      </vs-switch>
			    </li>
			  </ul>
				<vs-list>
					<vs-list-header title="Asignaturas" color="primary"></vs-list-header>
					<div id="asignaturas-list-container">
					<VuePerfectScrollbar class="asignaturas-list-scroll-area" :settings="scrollSettings">
						<draggable 
						:list="showAsignaturasList" 
						:options="{group:{name:'horario', pull:'clone', put:false}, sort:false}"
						class="p-2 cursor-move text-center">
							<div class="container-materia" v-for="asignatura, index in showAsignaturasList" :key="index">
								<span>{{asignatura.nombreAsignatura}}</span>
							</div>
							<!-- <div class="container-materia" v-for="element in 20">
								<span>Programación orientada a objetos con lenguaje de programación Java</span>
							</div> -->
							<!-- <vs-chip v-for="asignatura, index in showAsignaturasList" :key="index">{{asignatura.nombreAsignatura}}</vs-chip> -->
						</draggable>
					</VuePerfectScrollbar>
					</div>
				</vs-list>
			</div>
			<div class="w-full md:w-5/6">
				<slot name="alert"></slot>
				<vx-card>
					<vs-table 
						stripe 
						notSpacer
						maxHeight="500px"
						:data="horario">
						<template
							slot="thead">
							<vs-th>Hora</vs-th>
							<vs-th>Lunes</vs-th>
							<vs-th>Martes</vs-th>
							<vs-th>Miércoles</vs-th>
							<vs-th>Jueves</vs-th>
							<vs-th>Viernes</vs-th>
							<vs-th>Sábado</vs-th>
							<vs-th>Domingo</vs-th>
						</template>
						<template 
							slot-scope="{data}">
							<vs-tr 
								:key="indextr" 
								v-for="(tr, indextr) in data">

								<vs-td  
									:data="data[indextr].horaHorario">
									{{data[indextr].horaHorario}}
								</vs-td>

								<vs-td
									v-for="day in weekdays"
									:data="data[indextr][day]">
									<draggable 
										:list="data[indextr][day]" 
										:options="{group:'horario'}"
										@change="deleteSecondItem($event, data[indextr][day])"
										class="p-2 cursor-move">
							      <vs-chip 
							      	closable
							      	@click="removeAsignatura(asignatura, data[indextr][day])"
							      	@touchend.native="removeAsignatura(asignatura, data[indextr][day])"
							      	color="primary"
							      	v-for="(asignatura, index) in data[indextr][day]" 
							      	:key="index"> {{ asignatura.nombreAsignatura }} </vs-chip>
							    </draggable>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import VuePerfectScrollbar from 'vue-perfect-scrollbar'
	export default{
		props:['listaMaterias'],
		data(){
			return{
				materias: this.listaMaterias,
				horario: this.createHorario(),
				detalleHorario: [],
				mediasHoras: false,
				countClicksSwitch: 0,
				weekdays: [
			  	'monday',
			    'tuesday',
			    'wednesday',
			    'thursday',
			    'friday',
			    'saturday',
			    'sunday'
			  ],
			  asignaturasInscritas: [],
			  errorAsignaturasConsecutivas: {
					isError: false,
					asignatura: ''
				},
				scrollSettings: {
					maxScrollbarLength: 60,
					wheelSpeed: 0.30,
				}
			}
		},
		methods:{
			changeMediasHorasSwitch(){
				if (this.countClicksSwitch % 2 != 0) {
					this.mediasHoras = false;
				}
				this.countClicksSwitch++
			},
			createDetalleHorario(){
				this.detalleHorario = [];
				this.errorAsignaturasConsecutivas = {
					isError: false,
					asignatura: ''
				};
				// console.log(JSON.stringify(this.materias));
				// console.log('//////////////')
				// console.log(JSON.stringify(this.horario));

				this.materias.forEach((elMateria, inx)=>{
				// this.listaMaterias.forEach((elMateria, inx)=>{
					let asignatura = elMateria
				  asignatura.dias = []
				  
				  let arrayDias = [
				  	{
				  		idDia:2,
				      nombreDia: 'Lunes',
				      diaIngles: 'monday',
				      horas:[]
				    },
				    {
				    	idDia:3,
				      nombreDia: 'Martes',
				      diaIngles: 'tuesday',
				      horas:[]
				    },
				    {
				    	idDia:4,
				      nombreDia: 'Miércoles',
				      diaIngles: 'wednesday',
				      horas:[]
				    },
				    {
				    	idDia:5,
				      nombreDia: 'Jueves',
				      diaIngles: 'thursday',
				      horas:[]
				    },
				    {
				    	idDia:6,
				      nombreDia: 'Viernes',
				      diaIngles: 'friday',
				      horas:[]
				    },
				    {
				    	idDia:7,
				      nombreDia: 'Sábado',
				      diaIngles: 'saturday',
				      horas:[]
				    },
				    {
				    	idDia:1,
				      nombreDia: 'Domingo',
				      diaIngles: 'sunday',
				      horas:[]
				    }
				  ]
				  
				  this.horario.forEach((elHorario, indxHorario) => {
				  	
				  	arrayDias.forEach((elementDia, index) => {
				  		elHorario[elementDia.diaIngles].forEach((elHorarioDia, indxMonday)=>{
					    	if(elMateria.idAsignatura == elHorarioDia.idAsignatura){
					        elementDia.horas.push(parseInt(elHorario.horaHorario.replace(':', '')))
					      }
					    })
				  	})
				    
				  })
				  
				  arrayDias.forEach(elementDia => {

				  	  if(elementDia.horas.length != 0){

				  	  	// Bloque para identificar si no se puso una asignatura consecutivamente, solo sirve para horas completas y no para
				  	  	// medias horas.
				  	  	if (elementDia.horas.length > 1) {
				  	  		console.log('identify error half hour')
				  	  		console.log(elementDia.horas)

				  	  		if (this.mediasHoras) {
				  	  			elementDia.horas.forEach((elementHora, indexHora, arrayHoras)=>{
				  	  				let sumToCompare = ((elementHora + 70) % 100 == 0) ? 70:30;
					  	  			if (arrayHoras.length - 1 != indexHora
					  	  					&& elementHora + sumToCompare != arrayHoras[indexHora + 1]) {
				  	  					this.errorAsignaturasConsecutivas = {
				  	  						isError: true,
				  	  						asignatura: elMateria.nombreAsignatura
				  	  					};
					  	  			}
					  	  		})
				  	  		}else{
					  	  		elementDia.horas.forEach((elementHora, indexHora, arrayHoras)=>{
					  	  			if (arrayHoras.length - 1 != indexHora
					  	  					&& elementHora + 100 != arrayHoras[indexHora + 1]) {
				  	  					this.errorAsignaturasConsecutivas = {
				  	  						isError: true,
				  	  						asignatura: elMateria.nombreAsignatura
				  	  					};
					  	  			}
					  	  		})
				  	  		}
				  	  	}
				  	  	// 

				  	  	//lodash function
				  	  	let horaInicio = _.min(elementDia.horas)
				        //lodash function
				  	  	let horaFin = _.max(elementDia.horas)
				  	  	if (!this.mediasHoras) {
				  	  		horaFin += 100;
				  	  	}else if(this.mediasHoras){
				  	  		if (horaFin % 100 == 0) {
				  	  			horaFin += 30;
				  	  		}else{
				  	  			horaFin += 70;
				  	  		}
				  	  	}
				        elementDia.inicio = this.formatToHour(horaInicio);
				        elementDia.fin = this.formatToHour(horaFin); 
				      }else{
				        elementDia.inicio = '';
				        elementDia.fin = '';
				      }
				      delete elementDia.horas;
				      asignatura.dias.push(elementDia);
				  })
				  
					this.detalleHorario.push(asignatura)
				})
				// console.log(this.errorAsignaturasConsecutivas);
				// console.log(this.detalleHorario)
				// console.log(JSON.stringify(this.detalleHorario))

				// console.log(JSON.stringify(this.horario))
				this.setAsignaturasInscritas();
				this.passAsignaturasInscritas();
				this.passErrorAsignaturaConsecutiva();
				this.passDetalleHorario();
				
			},
			createHorario(){
				let horario = [];
				let hora = {};
				let countIdHora = 1
				let horaHorario = ''
				for (var indexHora = 7; indexHora <= 22 ; indexHora++) {
					if (this.mediasHoras) {
						for (var i = 0; i <= 1; i++) {
							i == 0 && this.mediasHoras? horaHorario = `${indexHora}:00` : horaHorario = `${indexHora}:30`;
							hora = {
								idHora: countIdHora++,
								'horaHorario': horaHorario,
								"monday":[],
								"tuesday":[],
								"wednesday":[],
								"thursday":[],
								"friday":[],
								"saturday":[],
								"sunday":[]
							};
							horario.push(hora);
							hora = {};
							if (i==1 && indexHora==22) {horario.pop()}
						}
					}else{
						hora = {
							idHora: countIdHora++,
							'horaHorario': `${indexHora}:00`,
							"monday":[],
							"tuesday":[],
							"wednesday":[],
							"thursday":[],
							"friday":[],
							"saturday":[],
							"sunday":[]
						};
						horario.push(hora);
						hora = {};
					}
				}
				return horario;
			},
			deleteSecondItem(event, materiasArray){
				if ('added' in event) {
					if (materiasArray.length >= 2) {
						materiasArray.shift();
						materiasArray.pop();
						materiasArray.push(event.added.element);
					}
				}
				this.createDetalleHorario();
			},
			formatToHour(numberToHour){
				let hour = numberToHour.toString();
				hour = _.map(hour);
				if(_.map(hour).length === 3){
				  hour.unshift('0')
				  hour.splice(2, 0, ':');
				}else{
					hour.splice(2, 0, ':');
				}
				return hour.join('');
			},
			passDetalleHorario(){
				this.$emit('onChangeDetalleHorario', this.detalleHorario);
			},
			passAsignaturasInscritas(){
				this.$emit('onChangeAsignaturasInscritas', this.asignaturasInscritas);
			},
			passErrorAsignaturaConsecutiva(){
				this.$emit('onChangeErrorAsignaturasConsecutivas', this.errorAsignaturasConsecutivas);
			},
			removeAsignatura(asignatura, asignaturaArray){
				asignaturaArray.forEach((element, index) => {
					if (element.idAsignatura == asignatura.idAsignatura) {
						asignaturaArray.splice(index, 1);
					}
				});
				this.createDetalleHorario();
			},
			setAsignaturasInscritas(){
				this.asignaturasInscritas = []
				this.horario.forEach((elementHorario, indexHorario) =>{
					this.weekdays.forEach(elementDay =>{
				    elementHorario[elementDay].forEach(elementHorarioDay=>{
				      this.asignaturasInscritas.push(elementHorarioDay)
				    })
				  })
				})
				this.asignaturasInscritas = _.uniqWith(this.asignaturasInscritas, _.isEqual())
				// console.log(this.asignaturasInscritas.length);
				// console.log(JSON.stringify(this.asignaturasInscritas));
			}
		},
		computed:{
			showAsignaturasList(){
				this.horario = this.createHorario();
				this.materias = this.listaMaterias;
				return this.listaMaterias;
			}
		},
		components:{
			draggable,
			VuePerfectScrollbar
		}
	}
</script>

<style lang="scss">
.container-materia{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 20px;
  background-color: #f0f0f0;
  font-size: .8rem;
  min-height: 26px;
  align-items: center;
  margin: 2px 3px;
  justify-content: center;
  color: rgba(0,0,0,.7);
}
.container-materia-primary{
	background-color: #0d578f;
	color: #fff;
}

.sticky-col{
	position: absolute;
	left: 0
}

.no-padding{
	padding: 0!important;
}
.asignaturas-list-scroll-area{
	position: relative;
  margin: auto;
  width: 100%;
  height: calc(100% - 5px);
}

#asignaturas-list-container{
	height: 400px;
	@media (max-width: 767px){
		height: 200px;
	}
}


</style>

<style scoped>
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-table td {
	padding: 0;
}

.vs-table--tbody-table .tr-table td {
	padding: 0;
}
	
</style>